module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'with-menu': _vm.showMenu, 'ready': _vm.appIsReady
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.appIsReady),
      expression: "!appIsReady"
    }],
    staticClass: "splash"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./assets/logo.png"),
      "alt": "SlackArchives.org"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error),
      expression: "!error"
    }],
    staticClass: "loader loader-sm"
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error",
    class: 'error-' + _vm.errorType
  }, [_vm._v(_vm._s(_vm.error) + "\n    "), (!_vm.errorType) ? _c('span', [_c('span', {
    staticClass: "smiley"
  }, [_vm._v("☹")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://slack-archives.org/#support",
      "target": "_blank"
    }
  }, [_vm._v("Let us know")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.appIsReady) ? _c('top-bar', {
    attrs: {
      "team": _vm.team
    },
    on: {
      "toggleMenu": _vm.onMenuToggle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.appIsReady) ? _c('side-bar', {
    attrs: {
      "team": _vm.team,
      "channels": _vm.channels
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "main_container"
    }
  }, [_c('router-view', {
    attrs: {
      "channel": _vm.channel,
      "team": _vm.team,
      "channelIDsToName": _vm.channelIDsToName,
      "appIsReady": _vm.appIsReady
    },
    on: {
      "error": _vm.onError
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25441132!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 255
// module chunks = 2